import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../../../contexts/authContext';
import { projectDataClient } from '../../../../../lib/connect/clients';
/**
 * GetProposalHome for the v3 page. Same freshness rule as ProposalReadiness: recheck authority on
 * every visit, and a failed read never shows cached names or counts.
 */ export function useProposalHome(projectId) {
    const { user } = useAuth();
    const principal = user ? `${user.tenant_id}:${user.id}` : '';
    return useQuery({
        queryKey: [
            'proposal-home',
            principal,
            projectId
        ],
        enabled: !!user && !!projectId,
        queryFn: ({ signal })=>projectDataClient.getProposalHome({
                projectId
            }, {
                signal
            }),
        retry: false,
        gcTime: 0,
        refetchOnMount: 'always'
    });
}
/** First page of the caller's assigned section work; same query (and cache entry) as AssignedSectionWork. */ export function useMyProposalSections(projectId) {
    const { user } = useAuth();
    return useQuery({
        queryKey: [
            'proposal-assigned-actions',
            user?.tenant_id,
            user?.id,
            projectId,
            0
        ],
        enabled: !!user && !!projectId,
        queryFn: ()=>projectDataClient.listMyProposalAssignedActions({
                projectId,
                limit: 20,
                offset: 0
            })
    });
}
